import '@fontsource/poppins';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';

export const fonts = {
    heading: '\'Poppins\', sans-serif',
    body: '\'Poppins\', sans-serif'
};
